/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LlmLayout } from '../../models/llm-layout';

export interface LlmConfigurationGetLayoutsFleetIdGet$Params {
  fleetId: string;
}

export function llmConfigurationGetLayoutsFleetIdGet(http: HttpClient, rootUrl: string, params: LlmConfigurationGetLayoutsFleetIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LlmLayout>>> {
  const rb = new RequestBuilder(rootUrl, llmConfigurationGetLayoutsFleetIdGet.PATH, 'get');
  if (params) {
    rb.path('fleetId', params.fleetId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LlmLayout>>;
    })
  );
}

llmConfigurationGetLayoutsFleetIdGet.PATH = '/LLMConfiguration/GetLayouts/{fleetId}';
